<template>
    <button-text
        :disabled="!canCancel"
        @click="onClick"
    >
        <svg-icon
            :icon="IconBan"
            :color="canCancel ? 'red-500' : 'gray-400'"
            is-custom-icon
        />
        <text-decorator :color="canCancel ? 'primary' : 'gray-400'">
            Uitschrijven voor alle en toekomstige e-mails
        </text-decorator>
    </button-text>
    <cancel-executions-for-contact-confirmation-dialog
        :visible="confirmationVisible"
        @confirm="onConfirm"
        @cancel="confirmationVisible = false"
    />
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue';
    import { CancelExecutionsForContactCommand, ContactId } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useNotify from '@/services/keyvue-ui/composables/useNotify';
    import IconBan from '@keyvue/one-awesome-icons/icons/regular/ban.svg?component';
    import CancelExecutionsForContactConfirmationDialog from '@/flow/execution/components/CancelExecutionsForContactConfirmationDialog.vue';

    const props = defineProps<{ contactId: ContactId }>();
    const { client } = useClient();
    const { notifySaved, notifyError } = useNotify();

    const confirmationVisible = ref(false);

    const canCancel = computed(() => {
        return true; // !contact.isOptedOut?
    });

    function onClick() {
        confirmationVisible.value = true;
    }

    async function onConfirm() {
        if (!canCancel.value) {
            return;
        }

        try {
            await client.dispatch(new CancelExecutionsForContactCommand(props.contactId));
            notifySaved(undefined, 'De contactpersoon is uitgeschreven voor alle toekomstige e-mails');
            confirmationVisible.value = false;
        } catch (error) {
            notifyError(error);
        }
    }
</script>
